
import Vue from 'vue'
import { functions } from '@/firebase/functions'
import { showSnackbar } from '@/globalActions'

// Club dashboard
export default Vue.extend({
  name: 'ClubPage',
  data () {
    return {
      activeTab: null,
      dialogStaff: false,
      validStaffForm: false,
      name: '',
      published: false,
      spiideo_assets_id: null as string | null,
      spiideoSyncing: false,
      staffForm: {
        firstname: '',
        lastname: '',
        nameRules: [
          (v: any) => !!v || 'Name is required'
        ],
        email: '',
        emailRules: [
          (v: any) => !!v || 'E-mail is required',
          (v: any) => /.+@.+/.test(v) || 'E-mail must be valid'
        ]
      },
      snackbar: false,
      text: '',
      team: {}
    }
  },
  computed: {
    isSpiideoSynced (): boolean {
      return !!this.spiideo_assets_id
    }
  },
  mounted () {
    this.loadClub()
  },
  destroyed () {
    this.$store.dispatch('ClubTeamsModule/closeDBChannel')
    this.$store.dispatch('PlayersModule/closeDBChannel')
  },
  methods: {
    loadClub () {
      this.$store.dispatch('ClubsModule/fetchById', this.$route.params.id).then(() => {
        const club = this.$store.state.ClubsModule.data[this.$route.params.id]
        this.name = club.name
        this.published = club.published || false
        this.spiideo_assets_id = club.spiideo_assets_id || null
      })
    },
    openDialogStaff () {
      this.$data.dialogStaff = true
    },
    sendInvitation () {
      this.$data.text = 'Invitation sent!'
      this.$data.snackbar = true
    },
    updateVisibility () {
      this.$store.dispatch('ClubsModule/patch', { id: this.$route.params.id, published: this.published })
    },
    async syncToSpiideo () {
      if (!this.$route.params.id || this.isSpiideoSynced) {
        return
      }
      this.spiideoSyncing = true
      try {
        const syncClub = functions.httpsCallable('spiideoSyncClubV2')
        const result: any = await syncClub({ clubId: this.$route.params.id })
        this.spiideo_assets_id =
          (result && result.data && result.data.spiideo_assets_id) || null
        showSnackbar(this.$t('spiideo-club-logo-synced') as string)
        await this.loadClub()
      } catch (err: any) {
        console.error('spiideoSyncClubV2', err)
        const message =
          (err && err.message) ||
          (this.$t('spiideo-sync-failed') as string)
        showSnackbar(message, { duration: 5000 })
      } finally {
        this.spiideoSyncing = false
      }
    }
  }
})
